import styled, { css } from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.button.attrs({ type: 'button' })<{ $focused?: boolean }>`
  width: 100%;
  padding: 8px 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  &:hover {
    background: ${Colors.GS200};
  }

  ${({ $focused }) =>
    $focused &&
    css`
      background: ${Colors.GS200};
    `}
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;
`

export const MainCategory = styled.div`
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  white-space: nowrap;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Subcategories = styled.div`
  width: 100%;
  color: ${Colors.GS600};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.1px;
  white-space: nowrap;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const IconContainer = styled.div`
  color: ${Colors.GS600};
`
